import { useAuiState } from '@assistant-ui/react';
import { Button, Modal, Stack, Text, Textarea } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBug } from '@tabler/icons-react';
import { useState } from 'react';

import { DownloadButton } from '#core/components/shared/DownloadButton.tsx';

/** Button with modal form for reporting issues, bundling thread diagnostic data into a downloadable JSON file. */
export function ReportIssue() {
  const [opened, { open, close }] = useDisclosure(false);
  const [description, setDescription] = useState('');

  const threadId = useAuiState(({ threadListItem }) => threadListItem.id);
  const messages = useAuiState(({ thread }) => thread.messages);

  const diagnosticData = JSON.stringify(
    {
      reportedAt: new Date().toISOString(),
      description,
      thread: { id: threadId, messages },
    },
    null,
    2,
  );

  return (
    <>
      <Button fullWidth leftSection={<IconBug size={14} />} onClick={open} size="xs" variant="subtle">
        Report issue
      </Button>

      <Modal centered onClose={close} opened={opened} title="Report issue">
        <Stack>
          <Text c="dimmed" size="sm">
            Describe the issue you encountered. Your diagnostic data will be included in the downloaded report. Share
            the downloaded file with the support team.
          </Text>
          <Textarea
            autosize
            label="Issue description"
            minRows={3}
            onChange={(e) => setDescription(e.currentTarget.value)}
            placeholder="Describe what happened..."
            value={description}
          />
          <DownloadButton
            data={diagnosticData}
            fileName={`issue-report-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.json`}
            mimeType="application/json"
            tooltip="Download diagnostic report"
          />
        </Stack>
      </Modal>
    </>
  );
}
